// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"b279a916","769":"c145dea0"}[chunkId] + ".chunk.js";
};